import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import * as showdown from 'showdown';
import { ActivatedRoute } from '@angular/router';
var GenericPageComponent = (function () {
    function GenericPageComponent(http, sanitizer, translate, route) {
        var _this = this;
        this.http = http;
        this.sanitizer = sanitizer;
        this.translate = translate;
        this.route = route;
        this.ngUnsubscribe = new Subject();
        this.page = '';
        this.pageTitle = '';
        this.lang = translate.currentLang;
        this.page = this.route.snapshot.data['page'];
        this.pageTitle = this.route.snapshot.data['title'];
        this.loadMarkdownFile();
        translate.onLangChange.takeUntil(this.ngUnsubscribe).subscribe(function () {
            _this.lang = translate.currentLang;
            _this.loadMarkdownFile();
        });
    }
    GenericPageComponent.prototype.loadMarkdownFile = function () {
        var _this = this;
        this.http
            .get('assets/i18n/' + this.page + '/' + this.lang + '.md')
            .takeUntil(this.ngUnsubscribe)
            .subscribe(function (text) {
            _this.text = text['_body'];
            _this.convertMarkdown();
        }, function () {
            _this.http
                .get('assets/i18n/' + _this.page + '/de.md')
                .takeUntil(_this.ngUnsubscribe)
                .subscribe(function (text) {
                _this.text = text['_body'];
                _this.convertMarkdown();
            }, function () { });
        });
    };
    GenericPageComponent.prototype.convertMarkdown = function () {
        this.converter = new showdown.Converter({ tables: true, disableForced4SpacesIndentedSublists: true });
        this.html = this.sanitizer.bypassSecurityTrustHtml(this.converter.makeHtml(this.text));
    };
    /**
    * On destroy cancel active subscriptions
    */
    GenericPageComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return GenericPageComponent;
}());
export { GenericPageComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/generic-page/generic-page.component.ts.pre-build-optimizer.js